module.exports = __webpack_public_path__ + "static/media/rohit_dua.63e84b24.jpeg";